import { ChakraStatusType } from './types';

export const CHAKRA_STATUS = {
  AGREABLE: 'AGREABLE' as ChakraStatusType,
  DISAGREABLE: 'DISAGREABLE' as ChakraStatusType,
  NEUTRAL: 'NEUTRAL' as ChakraStatusType,
};
